class FantasticZipCode extends HTMLElement {
  constructor() {
    super();

    this.container = document.createElement("div");
    this.container.classList = "ff-zipcodes";
    this.appendChild(this.container);

    this.zipCodes = this.dataset.zipCodes.replace(/\s+/g, "");
    this.result = document.createElement("p");
    this.titleResult = document.createElement("span");
    this.customInput = this.querySelector("#zipCode");

    const parent = this;
    this.customInput.addEventListener("input", function () {
      const filter = this.value.trim();
      const postalCodes = parent.zipCodes.split(",");

      parent.result.innerHTML = "";

      const filteredPostalCodes = postalCodes.filter((code) => {
        if (filter === "") {
          parent.result.innerHTML = "";
          return;
        }

        return code.startsWith(filter);
      });

      if (filteredPostalCodes.length > 0) {
        parent.result.innerHTML = filteredPostalCodes.join(", ");
        parent.titleResult.innerHTML =
          "¡Enhorabuena! Envíamos al código postal introducido";
        parent.container.appendChild(parent.titleResult);
      } else {
        parent.titleResult.innerHTML = "";
        parent.result.innerHTML =
          filter !== "" ? "No se ha encontrado ningún código postal" : "";
      }

      parent.result.style.animation = "fadeIn 1s ease-in-out";
      parent.result.style.opacity = "1";
      parent.container.appendChild(parent.result);
    });
  }
}
customElements.define("fantastic-zip-code", FantasticZipCode);
